import { RentCoverageTypes, SecurityDepositTypes } from '@/constants/CoverageType';
import { checkIfPmi } from '@/utils/commonUtils';
import { Renter, RenterInviteType } from '@/utils/types/renter.interface';
import type { User } from '@/utils/types/User';
import { ScreeningResultsTypes } from '../ScreeningResultsTypes';

const applyNewFormDefaults = (payload: Renter) => {
  payload.rentCoverage = RentCoverageTypes.Customize;
  payload.securityDepositCoverage = SecurityDepositTypes.CustomizeOrRemove;
  payload.renterInviteType = RenterInviteType.SMBInviteNewLimitedSdr;
  payload.customCoverage = true;
  if (payload.monthsOfCoverage && payload.includeDepositCoverage) {
    payload.monthsOfCoverage = Math.max(0, payload.monthsOfCoverage - 1);
  }
};

const applyLegacyFormDefaults = (
  payload: Renter,
  user: User | null | undefined,
  isSmbRenterInvites: boolean,
) => {
  if (user && !checkIfPmi(user) && isSmbRenterInvites) {
    payload.renterInviteType = RenterInviteType.SMBInviteOldCustomCoverage;
  }
  if (payload.rentCoverage === RentCoverageTypes.CompanyDefault) {
    delete payload.monthsOfCoverage;
  }
  if (payload.securityDepositCoverage === SecurityDepositTypes.CompanyDefault) {
    delete payload.securityDepositReplacementAmount;
  }
};

export const buildLegacyRequestPayload = (
  values: Renter,
  useNewForm: boolean,
  user: User | null | undefined,
  isSmbRenterInvites: boolean,
): Record<string, unknown> => {
  const payload = { ...values };
  if (useNewForm) {
    applyNewFormDefaults(payload);
  } else {
    applyLegacyFormDefaults(payload, user, isSmbRenterInvites);
  }
  if (payload.customCoverage) {
    payload.approvalStatus = ScreeningResultsTypes.Denied;
  }
  const { address, ...rest } = payload;
  return {
    ...rest,
    building: { monolith_building_ids: [address.monolith_building_id] },
  };
};
